import React from "react";
import SeoArticlePage from "../../components/SeoArticlePage";

export default function QuittanceDeLoyer() {
  return (
    <SeoArticlePage
      seo={{
        title: "Quittance de loyer : modèle gratuit et génération automatique | 360immoinvest",
        description:
          "Générez et envoyez vos quittances de loyer en quelques clics. Mentions obligatoires, modèle conforme et envoi automatique au locataire. Gratuit pour 1 bien.",
        path: "/quittance-de-loyer",
        testid: "seo-quittance-page",
      }}
      eyebrow="Guide du bailleur"
      h1="Quittance de loyer : modèle et génération automatique"
      intro="La quittance de loyer atteste que votre locataire a bien payé son loyer et ses charges pour une période donnée. Avec 360immoinvest, elle se génère automatiquement à chaque paiement et s'envoie à votre locataire en un clic. Besoin d'une quittance tout de suite ? Utilisez notre générateur gratuit."
      sections={[
        {
          title: "Générer une quittance gratuitement, maintenant",
          paragraphs: [
            "Pas encore le temps de créer un compte ? Notre générateur en ligne vous permet de remplir et d'imprimer (ou d'enregistrer en PDF) une quittance conforme en quelques secondes, sans inscription et sans que vos données ne quittent votre appareil.",
          ],
        },
        {
          title: "Qu'est-ce qu'une quittance de loyer ?",
          paragraphs: [
            "La quittance de loyer est un document remis par le bailleur au locataire qui a réglé l'intégralité de son loyer et de ses charges. Elle distingue le montant du loyer et celui des charges, et couvre une période précise (en général un mois).",
            "À la différence d'un simple reçu, la quittance atteste du paiement complet. Si le locataire n'a réglé qu'une partie de la somme, le bailleur délivre un reçu partiel et non une quittance.",
          ],
        },
        {
          title: "Le bailleur est-il obligé de la fournir ?",
          paragraphs: [
            "Oui. Lorsque le locataire en fait la demande, le bailleur est tenu de lui transmettre gratuitement une quittance de loyer. Aucun frais ne peut être facturé pour ce document, y compris pour un envoi par voie électronique avec l'accord du locataire.",
          ],
        },
        {
          title: "Les mentions obligatoires",
          paragraphs: ["Une quittance conforme comporte les éléments suivants :"],
          bullets: [
            "Les nom et adresse du bailleur et du locataire",
            "L'adresse du logement loué",
            "La période concernée par le paiement",
            "Le détail des sommes : loyer hors charges et provisions pour charges, séparément",
            "La date du paiement et la date d'émission de la quittance",
          ],
        },
        {
          title: "Générer et envoyer vos quittances avec 360immoinvest",
          paragraphs: [
            "Dès qu'un loyer est marqué comme payé, l'application prépare la quittance au bon format, avec le détail loyer / charges et la période. Vous l'envoyez ensuite au locataire par e-mail, ou vous la téléchargez en PDF.",
            "Vos quittances sont archivées dans votre espace : vous retrouvez tout l'historique par bien et par locataire, utile en cas de contrôle ou de litige.",
          ],
        },
      ]}
      faq={[
        { q: "La quittance de loyer est-elle payante ?", a: "Non. Le bailleur doit la fournir gratuitement au locataire qui en fait la demande, y compris par e-mail." },
        { q: "Peut-on envoyer une quittance par e-mail ?", a: "Oui, l'envoi dématérialisé est autorisé dès lors que le locataire ne s'y oppose pas. 360immoinvest permet l'envoi par e-mail et le téléchargement en PDF." },
        { q: "Que faire en cas de paiement partiel ?", a: "En cas de paiement incomplet, on délivre un reçu mentionnant la somme versée, et non une quittance, qui suppose le règlement intégral du loyer et des charges." },
        { q: "Faut-il conserver les quittances ?", a: "Il est recommandé de les archiver : elles servent de preuve de paiement. L'application conserve automatiquement l'historique de vos quittances." },
      ]}
      related={[
        { to: "/quittance-de-loyer/generateur", label: "Générateur de quittance gratuit" },
        { to: "/revision-loyer-irl", label: "Révision de loyer (IRL)" },
        { to: "/declaration-revenus-fonciers", label: "Revenus fonciers" },
        { to: "/tarifs", label: "Voir les tarifs" },
      ]}
    />
  );
}
